import React, { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

interface PageWrapperProps {
    className?: string
}

export const PageWrapper: FC<PropsWithChildren<PageWrapperProps>> = ({ className, children }) => {
    return <Wrapper className={`mx-auto ${className}`}>{children}</Wrapper>
}

export const Wrapper = styled.div`
    width: 100%;
    position: relative;
    box-sizing: border-box;
    @media (min-width: 640px) {
        max-width: 640px;
    }
    @media (min-width: 768px) {
        max-width: 768px;
    }
    @media (min-width: 1024px) {
        max-width: 1024px;
    }
    @media (min-width: 1280px) {
        max-width: 1280px;
    }
    @media (min-width: 1440px) {
        max-width: 1296px;
    }
`
